export default __webpack_public_path__ + "static/media/logo.1e51ff56.png";